import { Link } from "react-router-dom";
import { Check, Globe, ArrowRight } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from "./ui/dropdown-menu";
import { CURRENCIES } from "../mock";
import { useLocale, SYM, FlagImg } from "../lib/locale";

const CURRENCY_ISO = { USD: "us", EUR: "eu", GBP: "gb", INR: "in", AED: "ae", AUD: "au", CAD: "ca" };

export function LocaleMenu() {
  const loc = useLocale();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="hidden sm:inline-flex h-9 items-center gap-1.5 rounded-full border border-transparent px-2.5 text-sm font-medium outline-none transition-colors hover:border-border hover:bg-muted" aria-label="Passport and currency" data-testid="nav-locale">
        <Globe className="h-3.5 w-3.5 text-label2" />
        <span data-testid="nav-locale-flag" aria-hidden="true" className="inline-flex"><FlagImg iso={loc.iso} /></span>
        <span className="text-label2" data-testid="nav-locale-currency">{loc.currency}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72 rounded-card p-3 shadow-card" data-testid="locale-menu">
        <p className="px-1 text-xs font-medium text-label2">Your passport</p>
        <p className="mt-0.5 px-1 text-xs text-label2">{loc.detected ? `Set from your location (${loc.detectedName || loc.passport}).` : "Detecting your location…"}</p>
        <div className="no-scrollbar mt-2 max-h-56 space-y-0.5 overflow-y-auto">
          {loc.options.map((o) => {
            const on = o.name === loc.passport;
            return (
              <button key={o.name} type="button" onClick={() => loc.setPassport(o.name)} aria-pressed={on} data-testid={`locale-passport-${o.iso}`} className={`flex w-full items-center gap-2.5 rounded-lg px-2 py-2 text-left text-sm transition-colors ${on ? "bg-gray6 font-semibold" : "hover:bg-gray6/70"}`}>
                <span className="inline-flex"><FlagImg iso={o.iso} /></span><span className="flex-1 truncate">{o.name}</span>{on && <Check className="h-4 w-4" />}
              </button>
            );
          })}
        </div>
        <p className="mt-3 px-1 text-xs font-medium text-label2">Currency</p>
        <div className="mt-2 grid grid-cols-4 gap-1" data-testid="locale-currencies">
          {CURRENCIES.map((c) => {
            const on = c === loc.currency;
            return <button key={c} type="button" onClick={() => loc.setCurrency(c)} aria-pressed={on} data-testid={`locale-currency-${c}`} title={`${c} (${SYM[c].trim()})`} className={`flex flex-col items-center gap-1 rounded-lg border px-1 py-1.5 text-xs font-semibold transition-colors ${on ? "border-foreground bg-foreground text-background" : "border-separator hover:bg-gray6"}`}><FlagImg iso={CURRENCY_ISO[c]} size={16} />{c}</button>;
          })}
        </div>
        <Link to="/destinations" className="mt-3 flex items-center justify-between rounded-lg px-2 py-2 text-sm font-medium text-tint-strong hover:bg-gray6/70" data-testid="nav-destinations-link">Browse all destinations <ArrowRight className="h-3.5 w-3.5" /></Link>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
